module.exports = __webpack_public_path__ + "img/address.7da90c8b.svg";